import React from 'react'
import { Button } from '@mui/material'
import EastIcon from '@mui/icons-material/East';
import WestIcon from '@mui/icons-material/West';

const TestForwardandBackward = ({ setActive, active, calculateScore }: any) => {

	// Function to increment count by 1
	const incrementCountCancel = () => {
		// Update state with incremented value 
		setActive(active = 1);

	};
	// Function to increment count by 1
	const incrementCount = () => {
		// Update state with incremented value
		if (active !== 16) {
			setActive(active + 1);
		}
	};
	// Function to decrementCount count by 1
	const decrementCount = () => {
		// Update state with incremented value
		if (active !== 1) {
			setActive(active - 1);
		}
	};

	return (
		<div>

			<div className='AddJob_main_container_bottom' >
				<div>
					<Button variant="outlined" onClick={incrementCountCancel}>Cancel</Button></div>
				<div className='AddJob_main_container_bottom_two' style={{ color: "#0b03fc" }}>

					<div className='AddJob_bottom_two' style={{ color: "#0b03fc" }}>
						<Button variant="outlined"
							onClick={decrementCount}>
							<WestIcon />
						</Button>

					</div>

					<div style={{ margin: 20 }} />
					{/* <div className='AddJob_bottom_two'>
						<Button variant="contained" onClick={incrementCount} className={"summary-bottom-btn"}>
							Next step
						</Button>
					</div> */}

					<div style={{ margin: 20 }} />
					<div className='AddJob_bottom_two' style={{ color: "#0b03fc" }}>
						<Button variant="outlined" onClick={() => { incrementCount(); calculateScore() }}>
							<EastIcon style={{ color: "#0b03fc" }} />
						</Button>
					</div>
				</div>
			</div>
		</div>
	)
}

export default TestForwardandBackward
